
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 8c-1.167-3.493-4.303-6-8-6a8.012 8.012 0 00-3.685.9L2.414 1 1 2.414 13.586 15 15 13.586l-1.63-1.63A9.026 9.026 0 0016 8zM8 4a4 4 0 014 4c0 .741-.21 1.429-.565 2.02L9.932 8.518A2 2 0 008 6c-.179 0-.35.028-.515.072L5.991 4.577A3.889 3.889 0 018 4zm0 8a4 4 0 01-4-4c0-.356.061-.695.149-1.024L1.913 4.741A9.118 9.118 0 000 8c1.167 3.493 4.303 6 8 6a8.02 8.02 0 002.703-.47l-1.68-1.679A3.962 3.962 0 018 12z"}})])
          )
        }
      }
    